module.exports = __webpack_public_path__ + "img/tmslg-currency-guide-1.c15c4eba.png";